import React from 'react'
import { getTextColor } from '@/functions/common/helper'
import CustomImage from '../shared/CustomImage'

const ProductCard = ({
    image,
    imagePreview,
    title,
    subTitle,
    allergens,
    note,
    price,
    buttonSection,
    rowDisplay = false,
    cartItem = false,
    color,
    productDetail = false,
    productCardClick = null,
    productBadge,
    sold = false
}) => {
    const formatAllergens = () => {
        let arr = []
        allergens?.map(item => {
            arr.push(`${item.category}`)
        })
        return arr
    }
    return (
        <div
            onClick={() => productCardClick?.()}
            style={{
                border: `${color ? `1px solid ${color.toString(16)}` : '1px solid black'}`
            }}
            className={`flex ${productCardClick && 'cursor-pointer'} ${
                rowDisplay
                    ? `${
                          cartItem
                              ? 'flex-row min-h-44 lg:min-h-0 lg:rounded-none lg:border-x-0 lg:border-b-0 lg:py-5 lg:border-turbo-gray'
                              : 'bg-turbo-gray flex-row min-h-44 lg:min-h-60 xl:min-h-72 2xl:min-h-96 lg:rounded-2xl xl:rounded-3xl  2xl:rounded-[2rem]'
                      }`
                    : 'shadow-container bg-turbo-gray flex-col flex-1 justify-end lg:rounded-2xl xl:rounded-3xl  2xl:rounded-[2rem]'
            } overflow-hidden rounded-xl ${productDetail ? ' productDetail lg:rounded-none relative' : ''}`}
        >
            <div className={'relative'}>
                {productBadge && (
                    <div
                        id={'product-badge'}
                        className={
                            'shadow-container absolute bg-turbo-background right-0 top-0 z-10 text-black p-4 rounded-bl-xl text-xl font-libre_franklin_bold '
                        }
                    >
                        {productBadge}
                    </div>
                )}
                {sold && (
                    <div
                        className={
                            'shadow-container absolute bg-turbo-primary left-0 top-0 z-10 text-white p-4 rounded-br-xl text-xl font-libre_franklin_bold '
                        }
                    >
                        Vyprodáno
                    </div>
                )}
                <CustomImage
                    rowDisplay={rowDisplay}
                    cartItem={cartItem}
                    image={image}
                    preview={imagePreview}
                    smaller={!subTitle}
                    productDetail={productDetail}
                />
            </div>

            <div
                style={{
                    backgroundColor: `${color ? color.toString(16) : 'white'}`,
                    color: color ? getTextColor(color) : 'black'
                }}
                className={`${image || subTitle ? 'flex-1' : ''} flex flex-col  tracking-0-04em ${
                    rowDisplay
                        ? `${
                              cartItem
                                  ? ' px-3 xs:pl-4 py-4 text-left   lg:flex-row lg:py-0 lg:px-4'
                                  : ' px-3 xs:pl-4 py-4 text-left   lg:pt-4 lg:pb-5 lg:px-6   xl:pt-6 xl:pb-8 xl:px-10   2xl:pt-9 2xl:pb-11 2xl:px-12'
                          }`
                        : ` text-center py-2 px-3   lg:pt-4 lg:pb-5 lg:px-6   xl:pt-6 xl:pb-8 xl:px-10   2xl:pt-9 2xl:pb-11 2xl:px-12 `
                    /*${
                                            subTitle
                                              ? 'py-2 px-3   lg:pt-4 lg:pb-5 lg:px-6   xl:pt-6 xl:pb-8 xl:px-10   2xl:pt-9 2xl:pb-11 2xl:px-12'
                                              : 'pt-2 pb-3  lg:pt-3 lg:pb-5  xl:pt-4 xl:pb-6  2xl:pt-6 2xl:pb-8'
                                          }*/
                } productDetailContent w-auto ${
                    productDetail ? ' lg:pl-12 lg:pr-0 xl:pl-20 xl:pr-0 2xl:pl-24 2xl:pr-0' : ''
                }`}
            >
                <div className={'flex-1'}>
                    {title && (
                        <div
                            className={` leading-none break-normal font-fk_screamer text-2xl tracking-0-03em ${
                                rowDisplay && cartItem ? ' lg:text-3xl' : ' lg:text-4xl xl:text-5xl 2xl:text-6xl'
                            } ${productDetail ? ' lg:text-turbo-primary' : ''}`}
                        >
                            {title}
                        </div>
                    )}
                    {subTitle && (
                        <>
                            <div
                                className={` font-libre_franklin flex-1 flex items-center text-sm  ${
                                    rowDisplay
                                        ? `${
                                              cartItem
                                                  ? 'py-5  lg:pb-0 lg:pt-3    xl:text-lg '
                                                  : 'py-5  lg:pb-7 lg:pt-8   xl:pb-9 xl:pt-11   2xl:pb-11 2xl:pt-14  xl:text-lg 2xl:text-xl'
                                          }`
                                        : 'py-5 justify-center lg:pb-7 lg:pt-8   xl:pb-9 xl:pt-11   2xl:pb-11 2xl:pt-14  xl:text-lg 2xl:text-xl'
                                } ${productDetail ? ' lg:flex-none' : ''}`}
                            >
                                <>
                                    {allergens && allergens.length !== 0 ? (
                                        <>{`${subTitle}  (${formatAllergens()})`}</>
                                    ) : (
                                        <>{subTitle}</>
                                    )}
                                </>
                            </div>
                            {}
                        </>
                    )}
                    {note && (
                        <div className={`flex font-libre_franklin_bold items-center  text-sm mt-3 break-all `}>
                            Poznámka: {note}
                        </div>
                    )}
                </div>
                {price && (
                    <div
                        className={`flex  ${
                            rowDisplay
                                ? `${
                                      cartItem
                                          ? 'flex-row lg:text-3xl lg:ml-5'
                                          : 'flex-row lg:text-4xl xl:text-5xl 2xl:text-6xl'
                                  }`
                                : ' flex-col xs:flex-row lg:text-4xl xl:text-5xl 2xl:text-6xl'
                        } ${
                            productDetail ? 'justify-start' : 'justify-between'
                        } items-center font-fk_screamer text-2xl tracking-0-03em gap-2 xs:gap-3 ${
                            productDetail ? 'lg:text-turbo-primary' : ''
                        }`}
                    >
                        <div
                            className={`${
                                rowDisplay && cartItem ? 'min-w-[50px] lg:min-w-[100px] lg:text-right lg:order-2' : ''
                            } ${productDetail && 'lg:min-w-32'} leading-none`}
                        >
                            {price}
                        </div>

                        {productDetail ? (
                            <div className={'invisible lg:visible lg:ml-36'}>{buttonSection}</div>
                        ) : (
                            <>{buttonSection && buttonSection}</>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
export default React.memo(ProductCard)
